import { EnqueueSnackbar } from 'notistack';

export async function notifyMonitorError(
  error: Response | string,
  enqueueSnackbar: EnqueueSnackbar
) {
  const errorText = typeof error === 'string' ? error : await error.text();
  if (errorText && errorText.includes('Maximum number')) {
    enqueueSnackbar(
      'You are already monitoring the maximum number of reports',
      { variant: 'error' }
    );
    return;
  }
  enqueueSnackbar(
    'Something went wrong, please try again or contact customer service',
    { variant: 'error' }
  );
}
